<script>
  import store from 'store';
  import Report from './components/report';

  export const reports = [
    {
      name: 'Registrations',
      description: `A list of all or some Event Registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations?authorization=` +
        store.get('token')
    },
    {
      name: 'People',
      description: `A list of all or some People`,
      url: `${GRAPHQL_API}/exports/people?authorization=` + store.get('token')
    },
    {
      name: 'Households',
      description: `A list of all or some Households`,
      url:
        `${GRAPHQL_API}/exports/households?authorization=` + store.get('token')
    },
    {
      name: 'Programs',
      description: `A list of all or some Programs`,
      url: `${GRAPHQL_API}/exports/programs?authorization=` + store.get('token')
    },
    {
      name: 'Events',
      description: `A list of all or some Events`,
      url: `${GRAPHQL_API}/exports/events?authorization=` + store.get('token')
    },
    {
      name: 'Registration Gender Distribution',
      description: `Gender distribution for Event registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations/distro/gender?authorization=` +
        store.get('token')
    },
    {
      name: 'Registration Ethnicity Distibution',
      description: `Ethnicity distribution for Event registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations/distro/ethnicity?authorization=` +
        store.get('token')
    },
    {
      name: 'Registration Age Distibution',
      description: `Age distribution for Event registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations/distro/age?authorization=` +
        store.get('token')
    },
    {
      name: 'Registration Postal Code Distibution',
      description: `Postal Code distribution for Event registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations/distro/postal?authorization=` +
        store.get('token')
    },
    {
      name: 'Registration Primary Category Distribution',
      description: `Primary Category distribution for Event registrations`,
      url:
        `${GRAPHQL_API}/exports/registrations/distro/category?authorization=` +
        store.get('token')
    }
  ];

  console.log(reports);
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <div class="grid-x grid-margin-x small-up-1 medium-up-1">
      {#each reports as report, i}
      <div class="cell">
        <Report report="{report}"></Report>
      </div>
      {/each}
    </div>
  </div>
</div>
